import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import ReturObatSvc from "@/services/ReturObatService";

@Module({ store, dynamic: true, namespaced: true, name: "retur-obat" })
class ReturObatModule extends VuexModule {
  items: any[] = [];
  currentItem: any = null;
  pendingList: any[] = [];
  loading = false;

  @Mutation SET_ITEMS(val: any[]) {
    this.items = val;
  }

  @Mutation SET_CURRENT_ITEM(val: any) {
    this.currentItem = val;
  }

  @Mutation SET_PENDING_LIST(val: any[]) {
    this.pendingList = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await ReturObatSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_ITEMS(data || []);
    } catch {
      this.SET_ITEMS([]);
    }

    this.SET_LOADING(false);
  }

  @Action async getDetail(id: number) {
    this.SET_LOADING(true);

    try {
      const dt = await ReturObatSvc.find(id);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }

    this.SET_LOADING(false);
  }

  @Action async fetchPending(depoId?: string) {
    this.SET_LOADING(true);

    try {
      const dt = await ReturObatSvc.listPending(depoId);
      const { data } = dt.data;
      this.SET_PENDING_LIST(data || []);
    } catch {
      this.SET_PENDING_LIST([]);
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_ITEMS([]);
    this.SET_CURRENT_ITEM(null);
    this.SET_PENDING_LIST([]);
  }
}

export const storeReturObat = getModule(ReturObatModule);
